export * from './club-injuries.model';



// WEBPACK FOOTER //
// ./src/app/pages/club-injuries/store/index.ts